const CampaignSetting = () => import('@/views/setting/campaign')

export default {
  path: 'campaign-setting',
  redirect: '/campaign-setting',
  component: {
    render(c) { return c('router-view') }
  },
  children: [
    {
      path: '/',
      name: 'campaign-setting',
      component: CampaignSetting,
      meta: {
        link: 'campaign-setting',
        breadcrumb: [
          { title: 'Setting', active: true },
          { title: 'Campaign', active: true }
        ],
        pageTitle: 'Campaign Setting'
      }
    }
  ]
}

